import axios from 'axios';
import { IResponse } from '../types';
import { IBloodPressureReadingUpdate } from './types';
import { IBloodPressureReading } from '../readings/types';

const apiUrl = 'blood-pressure-readings';

export const update = (data: IBloodPressureReadingUpdate): IResponse<IBloodPressureReading> =>
  axios({
    method: 'put',
    url: apiUrl,
    data,
  });

export default {};
